import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Check } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) {
      setError("Отсутствует токен восстановления");
      return;
    }
    if (password.length < 6) {
      setError("Пароль должен быть не короче 6 символов");
      return;
    }
    if (password !== password2) {
      setError("Пароли не совпадают");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(formatApiError(err, "Не удалось сменить пароль"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-page" className="mx-auto grid max-w-md px-4 py-16">
      <div className="rounded-3xl border border-line bg-white p-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Новый пароль</div>
        <h1 className="mt-2 text-3xl font-extrabold tracking-tightest text-ink">Сбросить пароль</h1>
        <p className="mt-2 text-sm text-muted">Придумайте новый пароль для аккаунта vip77.store.</p>

        {done ? (
          <div className="mt-10 text-center" data-testid="reset-success">
            <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-success/10 text-success">
              <Check size={22} />
            </div>
            <p className="mt-4 text-sm text-ink">Пароль изменён. Перенаправляем на страницу входа…</p>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-4">
            <label className="block">
              <span className="mb-1 block text-xs font-semibold text-muted">Новый пароль</span>
              <input
                required
                type="password"
                data-testid="reset-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink"
              />
            </label>
            <label className="block">
              <span className="mb-1 block text-xs font-semibold text-muted">Повторите пароль</span>
              <input
                required
                type="password"
                data-testid="reset-password-2"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink"
              />
            </label>
            {error && (
              <div data-testid="reset-error" className="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">{error}</div>
            )}
            <button
              data-testid="reset-submit"
              disabled={busy}
              type="submit"
              className="w-full rounded-full bg-ink py-3 text-sm font-semibold text-white transition-colors hover:bg-ink-soft disabled:opacity-50"
            >
              {busy ? "Сохраняем…" : "Сменить пароль"}
            </button>
          </form>
        )}

        <div className="mt-6 text-center text-sm text-muted">
          <Link to="/login" className="font-semibold text-ink hover:underline">← К входу</Link>
        </div>
      </div>
    </div>
  );
}
